export enum BusinessConfirmation {
    Pending = 'pending',
    Confirmed = 'confirmed',
    Manual = 'manual',
}
